import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import type * as React from 'react';

import { cn } from 'src/lib/utils';

const TooltipProvider = TooltipPrimitive.Provider;

const Tooltip = TooltipPrimitive.Root;

const TooltipTrigger = TooltipPrimitive.Trigger;

const TooltipContent = ({
  className,
  sideOffset = 4,
  ref,
  ...props
}: (React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content> & {
  className?: string;
  sideOffset?: number;
}) & {
  ref?: React.Ref<React.ComponentRef<typeof TooltipPrimitive.Content>>;
}) => (
  <TooltipPrimitive.Content
    className={cn(
      'fade-in-0 zoom-in-95 data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 animate-in overflow-hidden rounded-md border-border-default bg-card px-3 py-1.5 text-card-foreground text-sm shadow-md data-[state=closed]:animate-out dark:bg-tooltip',
      className,
    )}
    ref={ref}
    sideOffset={sideOffset}
    {...props}
  />
);
TooltipContent.displayName = TooltipPrimitive.Content.displayName;

export { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger };
